import * as React from 'react';
import { PiralDocsBreadcrumbsComponentProps } from '../scripts/types';

const Breadcrumbs: React.FC<PiralDocsBreadcrumbsComponentProps> = () => null;

export default Breadcrumbs;
